module.exports = __webpack_public_path__ + "img/right-arrow.ce0942a5.svg";